<template>
  <v-dialog 
    v-model="navigation.CRMWhatsappContactDialogIsVisible" 
    @update:model-value="navigation.CRMWhatsappContactDialogIsVisible == false ? closeCRMWhatsappContactDialog() : null" 
    :max-width="$vuetify.display.mobile ? '90vw' : '60vw'"
    @contextmenu.prevent="null"
    style="user-select: none; cursor: default;"
  >
    <v-card style="max-height: 90vh; display: flex; flex-direction: column;">
      <div style="position: sticky; top: 0; z-index: 10; background: white;">
        <v-card color="primary" rounded="0" elevation="0" class="headerCard">
          <div class="titleContainer">
            <v-icon color="indigo" size="large">mdi-account</v-icon>
            <v-icon color="indigo" style="margin-right: 10px;">{{ {'insert': 'mdi-plus-circle', 'update': 'mdi-pencil', 'delete': 'mdi-delete'}[navigation.action] }}</v-icon>
            <h3>{{ {'insert': 'AGREGAR', 'update': 'ACTUALIZAR', 'delete': 'ELIMINAR'}[navigation.action] }} CONTACTO</h3>
          </div>
          <div class="actionsContainer">
            <v-btn 
              @click="closeCRMWhatsappContactDialog()"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
              color="error" 
              class="hoverableText" 
            >
              <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
              <p>CERRAR</p>
            </v-btn>
          </div>
        </v-card>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
      </div>    
      <div style="padding: 15px;">
        <template v-if="navigation.action == 'delete'">
          <template v-if="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog">
            <div style="display: flex; flex-direction: column; align-items: center; gap: 10px;">
              <v-progress-circular color="indigo" indeterminate></v-progress-circular>
              <div style="display: flex; align-items: center; gap: 5px;">
                <v-icon color="indigo" size="small">mdi-account</v-icon>
                <p style="color: grey;">Cargando información del contacto...</p>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="dataContainer">              
              <div style="display: flex; flex-direction: column; gap: 10px;">
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo" size="small">mdi-barcode</v-icon>
                  <p><strong>ID: </strong>{{ navigation.CRMWhatsappContactID }}</p>
                </div>
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo" size="small">mdi-account</v-icon>
                  <p><strong>Nombre: </strong>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay({CRMWhatsappContactID: navigation.CRMWhatsappContactID, CRMWhatsappContactFirstName: input.CRMWhatsappContactFirstName, CRMWhatsappContactMiddleName: input.CRMWhatsappContactMiddleName, CRMWhatsappContactFirstSurname: input.CRMWhatsappContactFirstSurname, CRMWhatsappContactSecondSurname: input.CRMWhatsappContactSecondSurname}) }}</p>
                </div>
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo" size="small">mdi-phone</v-icon>
                  <p><strong>Teléfono: </strong>{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(`${input.CRMWhatsappContactPhoneNumberCode}${input.CRMWhatsappContactPhoneNumber}`, false) }}</p>
                </div>
              </div>
              <div style="display: flex; flex-direction: column; gap: 10px;">
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo" size="small">mdi-card-account-details</v-icon>
                  <p><strong>SSN: </strong>{{ input.CRMWhatsappContactSSN || 'No registrado' }}</p>
                </div>
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo" size="small">mdi-email</v-icon>
                  <p><strong>Correo electrónico: </strong>{{ input.CRMWhatsappContactEmail || 'No registrado' }}</p>
                </div>
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo" size="small">mdi-store</v-icon>
                  <p style="margin-right: 5px;"><strong>Localidad: </strong></p>
                  <template v-if="input.CRMWhatsappContactCRMLocalityID && systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == input.CRMWhatsappContactCRMLocalityID)">
                    <v-chip :color="systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == input.CRMWhatsappContactCRMLocalityID).CRMLocalityColor || 'primary'" variant="flat" elevation="2" label>
                      <p>{{ systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == input.CRMWhatsappContactCRMLocalityID).CRMLocalityName || 'No registrada' }}</p>
                    </v-chip>
                  </template>
                  <template v-else>
                    <v-chip color="primary" variant="flat" elevation="2" label>
                      <p>No registrada</p>
                    </v-chip>
                  </template>
                </div>
              </div>
            </div>
            <v-divider style="margin-top: 15px; margin-bottom: 15px;"></v-divider>
            <div style="display: flex; align-items: center; gap: 10px;">
              <v-checkbox-btn
                v-model="input.deleteCRMWhatsappContactConfirmation"
                color="indigo"
                density="compact"
                hide-details
                class="hoverableElement"
              ></v-checkbox-btn>
              <p style="color: grey;">El contacto, junto con <strong>toda</strong> su información asociada (historial de conversaciones, historial de órdenes, seguimientos, notas, ubicaciones, etc.), será <strong>eliminado permanentemente</strong> de la base de datos. Entiendo que esta acción es <strong>irreversible</strong></p>
            </div>
          </template>
        </template>
        <template v-else>
          <div style="display: flex; flex-direction: column; gap: 15px;">        
            <template v-if="navigation.action == 'update'">
              <v-text-field
                ref="CRMWhatsappContactID"
                v-model="navigation.CRMWhatsappContactID"
                :loading="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
                prepend-inner-icon="mdi-barcode"
                label="ID del contacto" 
                variant="outlined" 
                density="compact"
                autocomplete="off"
                disabled
                hide-details
              ></v-text-field>
            </template>
            <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
              <template v-slot:activator="{ props }">
                <v-autocomplete 
                  v-bind="props"
                  ref="CRMWhatsappContactCRMLocalityID"
                  v-model="input.CRMWhatsappContactCRMLocalityID"
                  :items="systemInformationData.CRMLocalities"
                  :loading="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
                  :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
                  prepend-inner-icon="mdi-store"
                  item-title="CRMLocalityName" 
                  item-value="CRMLocalityID" 
                  label="Localidad asignada (opcional)" 
                  variant="outlined"
                  density="compact"
                  autocomplete="off"
                  hide-no-data
                  clearable
                  chips
                  closable-chips
                  hide-details
                >
                  <template v-slot:chip="{ item }">
                    <v-chip :color="item.raw.CRMLocalityColor" variant="flat" elevation="2" label>
                      <p>{{ item.raw.CRMLocalityName }}</p>
                      <template v-slot:close>
                        <v-icon
                          @click="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactCRMLocalityID');"
                          size="smaller" 
                          class="hoverableElement"
                        >
                          mdi-close-circle
                        </v-icon>
                      </template>
                    </v-chip>
                  </template>
                  <template v-slot:item="{ props, item }">
                    <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                      <v-list-item 
                        v-bind="props" 
                        :title="null" 
                        :subtitle="null"
                        :active="input.CRMWhatsappContactCRMLocalityID == item.value"
                        class="hoverableText"
                        style="padding-top: 5px; padding-bottom: 5px;"
                      >
                        <template v-slot:prepend>
                          <v-checkbox-btn 
                            :model-value="input.CRMWhatsappContactCRMLocalityID == item.value" 
                            density="compact" 
                            hide-details 
                            readonly
                            style="margin-right: 10px;"
                          ></v-checkbox-btn>
                        </template>
                        <v-chip :color="item.raw.CRMLocalityColor" variant="flat" elevation="2" label>
                          <p>{{ item.raw.CRMLocalityName }}</p>
                        </v-chip>
                      </v-list-item>
                    </v-list>
                  </template>
                </v-autocomplete>
              </template>
              <span style="max-width: 400px; display: block;">La localidad asignada al contacto es la localidad de preferencia desde la cual se procesan las órdenes del contacto</span>
            </v-tooltip>
            <div style="display: flex; align-items: center; gap: 10px;">
              <v-autocomplete
                v-model="input.CRMWhatsappContactPhoneNumberCode"
                :items="$assets.default.countryCodePhoneNumberOptions"
                :loading="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
                :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action || navigation.action != 'insert'"
                prepend-inner-icon="mdi-barcode"
                variant="outlined"
                density="compact"
                autocomplete="off"
                item-title="metadata"
                item-value="code"
                label="Código de país"
                chips
                closable-chips
                hide-no-data
                hide-details
                clearable
                style="flex: 0 0 250px; max-width: 250px;"
              >
                <template v-slot:chip="{ item }">
                  <v-chip color="primary" variant="flat" elevation="2" label>
                    <div style="display: flex; align-items: center; gap: 5px;">
                      <p>{{ item.raw.flag }}</p>
                      <p>{{ item.raw.shortName }}</p>
                      <p>(+{{ item.raw.code }})</p>
                    </div>
                    <template v-slot:close>
                      <v-icon 
                        size="smaller"
                        class="hoverableElement"
                        @click.stop="input.CRMWhatsappContactPhoneNumberCode = null; $generalFunctions.default.blurInput(this, 'CRMWhatsappContactPhoneNumberCode');"
                      >
                        mdi-close-circle
                      </v-icon>
                    </template>
                  </v-chip>
                </template>
                <template v-slot:item="{ props, item }">
                  <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                    <v-list-item 
                      v-bind="props" 
                      :title="null" 
                      :subtitle="null"
                      :active="input.CRMWhatsappContactPhoneNumberCode == item.value"
                      class="hoverableText"
                      style="padding-top: 5px; padding-bottom: 5px;"
                    >
                      <template v-slot:prepend>
                        <v-checkbox-btn 
                          :model-value="input.CRMWhatsappContactPhoneNumberCode == item.value" 
                          density="compact" 
                          hide-details 
                          readonly
                          style="margin-right: 10px;"
                        ></v-checkbox-btn>
                      </template>
                      <div style="display: flex; align-items: center; gap: 10px;">
                        <p>{{ item.raw.flag }}</p>
                        <p>{{ item.raw.name }}</p>
                        <p>(+{{ item.raw.code }})</p>
                      </div>
                    </v-list-item>
                  </v-list>
                </template>
              </v-autocomplete>
              <v-text-field
                ref="CRMWhatsappContactPhoneNumber"
                v-model="input.CRMWhatsappContactPhoneNumber" 
                @keypress="$generalFunctions.default.allowOnlyNumberOnInput($event)"
                :loading="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
                :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action || navigation.action != 'insert'"
                prepend-inner-icon="mdi-phone"
                label="Número de teléfono" 
                variant="outlined" 
                density="compact"
                autocomplete="off"
                hide-details
                clearable
                style="flex: 1;"
              ></v-text-field>
            </div>
            <v-text-field 
              ref="CRMWhatsappContactSSN"
              v-model="input.CRMWhatsappContactSSN"
              :loading="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
              prepend-inner-icon="mdi-card-bulleted"
              label="Documento de identificación" 
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-details
              clearable
            ></v-text-field>
            <v-text-field 
              ref="CRMWhatsappContactEmail"
              v-model="input.CRMWhatsappContactEmail" 
              :loading="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
              prepend-inner-icon="mdi-email"
              label="Correo electrónico (opcional)" 
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-details
              clearable
            ></v-text-field>
            <v-text-field 
              ref="CRMWhatsappContactFirstName"
              v-model="input.CRMWhatsappContactFirstName" 
              :loading="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
              prepend-inner-icon="mdi-numeric-1-box"
              label="Primer nombre" 
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-details
              clearable
            ></v-text-field>
            <v-text-field 
              ref="CRMWhatsappContactMiddleName"
              v-model="input.CRMWhatsappContactMiddleName" 
              :loading="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
              prepend-inner-icon="mdi-numeric-2-box"
              label="Segundo nombre (opcional)" 
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-details
              clearable
            ></v-text-field>
            <v-text-field 
              ref="CRMWhatsappContactFirstSurname"
              v-model="input.CRMWhatsappContactFirstSurname" 
              :loading="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
              prepend-inner-icon="mdi-numeric-3-box"
              label="Primer apellido" 
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-details
              clearable
            ></v-text-field>
            <v-text-field 
              ref="CRMWhatsappContactSecondSurname"
              v-model="input.CRMWhatsappContactSecondSurname" 
              :loading="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
              prepend-inner-icon="mdi-numeric-4-box"
              label="Segundo apellido (opcional)" 
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-details
              clearable
            ></v-text-field>
            <template v-if="loader.getSystemInformationData || systemInformationData.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappContacts/blockCRMWhatsappContact')?.CRMAgentPermissionValue == '1'">
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
                <template v-slot:activator="{ props }">
                  <v-checkbox-btn 
                    v-bind="props" 
                    v-model="input.CRMWhatsappContactIsBlocked"
                    :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
                    label="Contacto bloqueado"
                    color="indigo" 
                    density="compact"
                    hide-details
                    class="hoverableText"
                    style="margin-top: 15px;"
                  ></v-checkbox-btn>
                </template>
                <span style="max-width: 400px; display: block;">Al bloquear el contacto, se dejará de recibir mensajes del mismo</span>
              </v-tooltip>
            </template>
            <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
              <template v-slot:activator="{ props }">
                <v-checkbox-btn 
                  v-bind="props" 
                  v-model="input.CRMWhatsappContactIsIncludedInWhatsappMarketingCampaigns" 
                  :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action"
                  label="Contacto incluido en campañas de marketing"
                  color="indigo" 
                  density="compact"
                  hide-details
                  class="hoverableText"
                  style="margin-bottom: 15px;"
                ></v-checkbox-btn>
              </template>
              <span style="max-width: 400px; display: block;">El contacto será incluido en las campañas de marketing</span>
            </v-tooltip>
          </div>
        </template>
      </div>
      <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
      <v-card color="primary" elevation="0" rounded="0" style="padding: 15px;">
        <v-tooltip :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action || validateInputForCRMWhatsappContactDialog(false).success" location="top"> 
          <template v-slot:activator="{ props }">
            <div v-bind="props">
              <v-btn 
                @click="navigation.action == 'insert' ? insertCRMWhatsappContact() : (navigation.action == 'update' ? updateCRMWhatsappContact() : deleteCRMWhatsappContact())" 
                :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog || loader.action || !validateInputForCRMWhatsappContactDialog(false).success" 
                color="indigo" 
                block 
                class="hoverableText"
              >
                <v-icon style="margin-right: 10px;">{{ {'insert': 'mdi-plus-circle', 'update': 'mdi-pencil', 'delete': 'mdi-delete'}[navigation.action] }}</v-icon>
                <h3>{{ {'insert': 'AGREGAR', 'update': 'ACTUALIZAR', 'delete': 'ELIMINAR'}[navigation.action] }} CONTACTO</h3>
              </v-btn>
            </div>
          </template>
          <span style="max-width: 400px; display: block;">{{ validateInputForCRMWhatsappContactDialog(false).result }}</span>
        </v-tooltip>
      </v-card>
   </v-card>
  </v-dialog>
</template>
  
<style scoped>
  .headerCard {
    padding: 15px;
    display: grid;
    justify-content: center;
    align-items: center;
    gap: 10px;
    grid-template-columns: repeat(2, 1fr);
  }
  
  .titleContainer {
    display: flex;
    align-items: center;
  }

  .actionsContainer {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }
  
  .dataContainer {
    gap: 10px;
    display: grid;
    justify-content: center;
    align-items: center;
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 1200px) {
    .dataContainer {
      grid-template-columns: repeat(1, 1fr);
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  export default {
    inject: ['$generalFunctions', '$displayFunctions', '$assets'],
    data: () => 
    ({
      input: 
      {
        deleteCRMWhatsappContactConfirmation: false,
        CRMWhatsappContactCRMLocalityID: null,
        CRMWhatsappContactPhoneNumberCode: null,
        CRMWhatsappContactPhoneNumber: null,
        CRMWhatsappContactSSN: null,
        CRMWhatsappContactEmail: null,
        CRMWhatsappContactFirstName: null,
        CRMWhatsappContactMiddleName: null,
        CRMWhatsappContactFirstSurname: null,
        CRMWhatsappContactSecondSurname: null,
        CRMWhatsappContactIsBlocked: false
      },
      navigation: 
      {
        CRMWhatsappContactDialogIsVisible: false,
        CRMWhatsappContactID: null,
        action: null
      },
      loader: 
      {
        getSystemInformationData: false,
        action: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        CRMLocalities: [],
        tooltipDisabled: false,
        updateSubscription: null
      },
    }),

    methods:
    {
      async insertCRMWhatsappContact(){
        if (this.validateInputForCRMWhatsappContactDialog(true).success){
          this.loader.action = true;
          const insertCRMWhatsappContactRequestQuery = 
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
            },
            'CRMWhatsappContactCRMLocalityID': this.input.CRMWhatsappContactCRMLocalityID,
            'CRMWhatsappContactPhoneNumber': `${this.input.CRMWhatsappContactPhoneNumberCode}${this.input.CRMWhatsappContactPhoneNumber}`,
            'CRMWhatsappContactSSN': this.input.CRMWhatsappContactSSN,
            'CRMWhatsappContactEmail': this.input.CRMWhatsappContactEmail,
            'CRMWhatsappContactFirstName': this.input.CRMWhatsappContactFirstName,
            'CRMWhatsappContactMiddleName': this.input.CRMWhatsappContactMiddleName,
            'CRMWhatsappContactFirstSurname': this.input.CRMWhatsappContactFirstSurname,
            'CRMWhatsappContactSecondSurname': this.input.CRMWhatsappContactSecondSurname
          };
          const insertCRMWhatsappContactResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/functions/insertCRMWhatsappContact', insertCRMWhatsappContactRequestQuery);
          if (insertCRMWhatsappContactResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappContact_success', 'success', 'Se ha agregado el contacto exitosamente', null, true);
            this.closeCRMWhatsappContactDialog();
          } else {  
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappContact_error', 'error', 'Ha ocurrido un error inesperado al agregar el contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
          this.loader.action = false;
        }
      },

      async updateCRMWhatsappContact(){
        if (this.validateInputForCRMWhatsappContactDialog(true).success){
          this.loader.action = true;
          const updateCRMWhatsappContactRequestQuery = 
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
            },
            'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
            'CRMWhatsappContactCRMLocalityID': this.input.CRMWhatsappContactCRMLocalityID,
            'CRMWhatsappContactSSN': this.input.CRMWhatsappContactSSN,
            'CRMWhatsappContactEmail': this.input.CRMWhatsappContactEmail,
            'CRMWhatsappContactFirstName': this.input.CRMWhatsappContactFirstName,
            'CRMWhatsappContactMiddleName': this.input.CRMWhatsappContactMiddleName,
            'CRMWhatsappContactFirstSurname': this.input.CRMWhatsappContactFirstSurname,
            'CRMWhatsappContactSecondSurname': this.input.CRMWhatsappContactSecondSurname,
            'CRMWhatsappContactIsBlocked': this.input.CRMWhatsappContactIsBlocked
          };
          const updateCRMWhatsappContactResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/functions/updateCRMWhatsappContact', updateCRMWhatsappContactRequestQuery);
          if (updateCRMWhatsappContactResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappContact_success', 'success', 'Se ha actualizado el contacto exitosamente', null, true);
            this.closeCRMWhatsappContactDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappContact_error', 'error', 'Ha ocurrido un error inesperado al actualizar el contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
          this.loader.action = false;
        }
      },

      async deleteCRMWhatsappContact(){
        if (this.validateInputForCRMWhatsappContactDialog(true).success){
          this.loader.action = true;
          const deleteCRMWhatsappContactRequestQuery = 
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
            },
            'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID
          };
          const deleteCRMWhatsappContactResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/functions/deleteCRMWhatsappContact', deleteCRMWhatsappContactRequestQuery);
          if (deleteCRMWhatsappContactResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappContact_success', 'success', 'Se ha eliminado el contacto exitosamente', null, true);
            this.closeCRMWhatsappContactDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappContact_error', 'error', 'Ha ocurrido un error inesperado al eliminar el contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
          this.loader.action = false;
        }
      },

      async selectCRMWhatsappContactFromCRMWhatsappContactDialog(){
        this.loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog = true;
        const selectCRMWhatsappContactFromCRMWhatsappContactRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID
        };
        const selectCRMWhatsappContactFromCRMWhatsappContactResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/functions/selectCRMWhatsappContactFromCRMWhatsappContactDialog', selectCRMWhatsappContactFromCRMWhatsappContactRequestQuery);
        if (selectCRMWhatsappContactFromCRMWhatsappContactResult.success){
          this.input.CRMWhatsappContactCRMLocalityID = selectCRMWhatsappContactFromCRMWhatsappContactResult.result.CRMWhatsappContactCRMLocalityID;
          const CRMWhatsappContactPhoneNumber = selectCRMWhatsappContactFromCRMWhatsappContactResult.result.CRMWhatsappContactPhoneNumber;
          let found = false;
          for (const countryCodePhoneNumberOption of this.$assets.default.countryCodePhoneNumberOptions){
            if (CRMWhatsappContactPhoneNumber.startsWith(countryCodePhoneNumberOption.code)){
              this.input.CRMWhatsappContactPhoneNumberCode = countryCodePhoneNumberOption.code;
              this.input.CRMWhatsappContactPhoneNumber = CRMWhatsappContactPhoneNumber.substring(countryCodePhoneNumberOption.code.length);
              found = true;
              break;
            }
          }
          if (!found){
            this.input.CRMWhatsappContactPhoneNumberCode = '506';
            this.input.CRMWhatsappContactPhoneNumber = CRMWhatsappContactPhoneNumber;
          }
          this.input.CRMWhatsappContactSSN = selectCRMWhatsappContactFromCRMWhatsappContactResult.result.CRMWhatsappContactSSN;
          this.input.CRMWhatsappContactEmail = selectCRMWhatsappContactFromCRMWhatsappContactResult.result.CRMWhatsappContactEmail;
          this.input.CRMWhatsappContactFirstName = selectCRMWhatsappContactFromCRMWhatsappContactResult.result.CRMWhatsappContactFirstName;
          this.input.CRMWhatsappContactMiddleName = selectCRMWhatsappContactFromCRMWhatsappContactResult.result.CRMWhatsappContactMiddleName;
          this.input.CRMWhatsappContactFirstSurname = selectCRMWhatsappContactFromCRMWhatsappContactResult.result.CRMWhatsappContactFirstSurname;
          this.input.CRMWhatsappContactSecondSurname = selectCRMWhatsappContactFromCRMWhatsappContactResult.result.CRMWhatsappContactSecondSurname;
          this.input.CRMWhatsappContactIsBlocked = selectCRMWhatsappContactFromCRMWhatsappContactResult.result.CRMWhatsappContactIsBlocked == 1;
          this.input.CRMWhatsappContactIsIncludedInWhatsappMarketingCampaigns = selectCRMWhatsappContactFromCRMWhatsappContactResult.result.CRMWhatsappContactIsIncludedInWhatsappMarketingCampaigns == 1;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappContactFromCRMWhatsappContactDialog_error', 'error', 'Ha ocurrido un error inesperado al seleccionar el contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.closeCRMWhatsappContactDialog();
        }
        this.loader.selectCRMWhatsappContactFromCRMWhatsappContactDialog = false;
      },

      validateInputForCRMWhatsappContactDialog(showSystemNotificationDialog){
        const regularExpressionChecker = /\S/;
        if (this.navigation.action == 'delete'){
          if (!this.input.deleteCRMWhatsappContactConfirmation){
            if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactDialog_error', 'warning', 'La confirmación de eliminación del contacto es obligatoria', null, false);
            return {success: false, result: 'La confirmación de eliminación del contacto es obligatoria'};
          }
          return {success: true, result: null};
        } else if (this.input.CRMWhatsappContactPhoneNumberCode == null){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactDialog_error', 'warning', 'El código de país del contacto es obligatorio', null, false);
          return {success: false, result: 'El código de país del contacto es obligatorio'};
        } else if (this.input.CRMWhatsappContactPhoneNumber == null || !regularExpressionChecker.test(this.input.CRMWhatsappContactPhoneNumber)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactDialog_error', 'warning', 'El número de teléfono del contacto es obligatorio', null, false);
          return {success: false, result: 'El número de teléfono del contacto es obligatorio'};
        } else if (this.input.CRMWhatsappContactPhoneNumber.length > 30){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactDialog_error', 'warning', 'El número de teléfono del contacto no puede exceder los 30 caracteres de longitud', null, false);
          return {success: false, result: 'El número de teléfono del contacto no puede exceder los 30 caracteres de longitud'};
        } else if (this.input.CRMWhatsappContactSSN == null || !regularExpressionChecker.test(this.input.CRMWhatsappContactSSN)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactDialog_error', 'warning', 'El documento de identificación del contacto es obligatorio', null, false);
          return {success: false, result: 'El documento de identificación del contacto es obligatorio'};
        } else if (this.input.CRMWhatsappContactSSN.length > 30){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactDialog_error', 'warning', 'El documento de identificación del contacto no puede exceder los 30 caracteres de longitud', null, false);
          return {success: false, result: 'El documento de identificación del contacto no puede exceder los 30 caracteres de longitud'};
        } else if (this.input.CRMWhatsappContactEmail != null && this.input.CRMWhatsappContactEmail.length > 100){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactDialog_error', 'warning', 'El correo electrónico del contacto no puede exceder los 100 caracteres de longitud', null, false);
          return {success: false, result: 'El correo electrónico del contacto no puede exceder los 100 caracteres de longitud'};
        } else if (this.input.CRMWhatsappContactFirstName == null || !regularExpressionChecker.test(this.input.CRMWhatsappContactFirstName)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactDialog_error', 'warning', 'El primer nombre del contacto es obligatorio', null, false);
          return {success: false, result: 'El primer nombre del contacto es obligatorio'};
        } else if (this.input.CRMWhatsappContactFirstName.length > 100){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactDialog_error', 'warning', 'El primer nombre del contacto no puede exceder los 100 caracteres de longitud', null, false);
          return {success: false, result: 'El primer nombre del contacto no puede exceder los 100 caracteres de longitud'};
        } else if (this.input.CRMWhatsappContactMiddleName != null && this.input.CRMWhatsappContactMiddleName.length > 100){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactDialog_error', 'warning', 'El segundo nombre del contacto no puede exceder los 100 caracteres de longitud', null, false);
          return {success: false, result: 'El segundo nombre del contacto no puede exceder los 100 caracteres de longitud'};
        } else if (this.input.CRMWhatsappContactFirstSurname == null || !regularExpressionChecker.test(this.input.CRMWhatsappContactFirstSurname)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactDialog_error', 'warning', 'El primer apellido del contacto es obligatorio', null, false);
          return {success: false, result: 'El primer apellido del contacto es obligatorio'};
        } else if (this.input.CRMWhatsappContactFirstSurname.length > 100){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactDialog_error', 'warning', 'El primer apellido del contacto no puede exceder los 100 caracteres de longitud', null, false);
          return {success: false, result: 'El primer apellido del contacto no puede exceder los 100 caracteres de longitud'};
        } else if (this.input.CRMWhatsappContactSecondSurname != null && this.input.CRMWhatsappContactSecondSurname.length > 100){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactDialog_error', 'warning', 'El segundo apellido del contacto no puede exceder los 100 caracteres de longitud', null, false);
          return {success: false, result: 'El segundo apellido del contacto no puede exceder los 100 caracteres de longitud'};
        }
        return {success: true, result: null};
      },

      async getSystemInformationData(){
        try {
          this.loader.getSystemInformationData = true;
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });        
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappContactDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappContactDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.getSystemInformationData = false;
      },

      async openCRMWhatsappContactDialog(CRMWhatsappContactID, action){
        this.input.deleteCRMWhatsappContactConfirmation = false;
        this.navigation.CRMWhatsappContactID = CRMWhatsappContactID;
        this.navigation.action = action;
        this.loader.action = false;
        this.navigation.CRMWhatsappContactDialogIsVisible = true;
        await this.getSystemInformationData();
        if (this.navigation.action == 'update' || this.navigation.action == 'delete') await this.selectCRMWhatsappContactFromCRMWhatsappContactDialog();
        else this.input.CRMWhatsappContactPhoneNumberCode = '506';

      },

      closeCRMWhatsappContactDialog(){
        this.navigation.CRMWhatsappContactDialogIsVisible = false;
        this.$emit('closeCRMWhatsappContactDialog');
      }
    }
  }
</script>